<template>
  <v-container class="form-container rounded-lg">
    <h1>Jauns uzņēmums</h1>
    <CreateForm :fields="fields" name="companies" />
  </v-container>
</template>

<script>
import { markRaw } from "vue";
import CreateForm from "@/Admin/components/CreateForm.vue";
import TextField from "@/Admin/components/form/TextField.vue";

import { ruleSetGen } from "@/Admin/helpers/rules";
export default {
  name: "CompaniesCreateView",
  components: { CreateForm },
  data() {
    return {
      fields: {
        name: {
          component: markRaw(TextField),
          data: {
            label: "Nosaukums",
            placeholder: "Ievadiet nosaukumu",
            name: "name",
            rules: ruleSetGen.text("Lūdzu ievadiet derīgu nosaukumu", true, 3),
          },
        },
        registration_number: {
          component: markRaw(TextField),
          data: {
            label: "Reģistrācijas nr.",
            placeholder: "Ievadiet reģistrācijas nr.",
            name: "registration_number",
            rules: ruleSetGen.text(
              "Lūdzu ievadiet derīgu reģistrācijas nr.",
              true,
              12,
            ),
          },
        },
      },
    };
  },
};
</script>

<style scoped>
.form-container {
  width: 1000px;
  margin: auto;
  background-color: white;
  padding: 10px;
}
</style>
